module.exports = __webpack_public_path__ + "static/media/renataadvogada.5d38cf66.jpg";